import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { Colours, MediaQueries } from '../../tokens';
import NavOption from './NavOption';
const getStyles = createUseStyles({
    root: {
        [MediaQueries.medium]: {
            marginBottom: '4.8rem',
        },
        [MediaQueries.large]: {
            position: 'relative'
        },
        '&:after': {
            [MediaQueries.large]: {
                content: '"\u2807"',
                fontSize: '2.6rem',
                lineHeight: '4.0rem',
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                width: '1rem',
                overflow: 'hidden',
                height: '100%',
                color: Colours.sexternary,
                transition: 'opacity 0.3s',
                opacity: 0,
            },
        },
    },
    isExpanded: {
        '&:after': {
            [MediaQueries.large]: {
                opacity: 1,
            }
        }
    }
});
const AccountNavOption = ({ children, className, isExpanded, icon }) => {
    const styles = getStyles();
    return (React.createElement(NavOption, { isExpanded: isExpanded, disabled: true, className: classNames(styles.root, { [styles.isExpanded]: isExpanded }, className), icon: icon }, children));
};
export default AccountNavOption;
//# sourceMappingURL=AccountNavOption.js.map